module.exports = __webpack_public_path__ + "img/google-icon.96fc955b.svg";